export default "__VITE_ASSET__DmZAk3KR__"